var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitiesincomplete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_11884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 5.32516C11.0297 5.16268 11.2501 5.07141 11.4799 5.07141C11.7098 5.07141 11.9302 5.16268 12.0927 5.32516L15.9927 9.22516C16.1552 9.38768 16.2464 9.60808 16.2464 9.83789C16.2464 10.0677 16.1552 10.2881 15.9927 10.4506L12.0927 14.3506C11.9292 14.5085 11.7103 14.5959 11.4831 14.5939C11.2558 14.5919 11.0385 14.5008 10.8778 14.3401C10.7171 14.1794 10.6259 13.962 10.624 13.7348C10.622 13.5075 10.7093 13.2886 10.8672 13.1252L13.2133 10.7046H4.97995C4.75009 10.7046 4.52965 10.6132 4.36712 10.4507C4.20459 10.2882 4.11328 10.0677 4.11328 9.83789C4.11328 9.60804 4.20459 9.3876 4.36712 9.22507C4.52965 9.06254 4.75009 8.97123 4.97995 8.97123H13.2133L10.8672 6.55063C10.7047 6.3881 10.6135 6.1677 10.6135 5.93789C10.6135 5.70808 10.7047 5.48768 10.8672 5.32516Z",
    fill: "#4A4A4A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5Z",
    stroke: "#8E6A50",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_11884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(3.67969 3.33789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesincomplete);
export default __webpack_public_path__ + "static/media/activitiesincomplete.cb6e2b77e626549e3acdece5afc4059e.svg";
export { ForwardRef as ReactComponent };